import { BookmarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import type { ToolCallPayload } from "../../api/threads/liveMessages";
import { ToolCallBody } from "../threads/entries/TurnEntries";
import type { AgentMemorySave } from "./agentSave";
import MemoryThreadLink from "./MemoryThreadLink";

/**
 * The visible notice when an agent's `save_memory` kept a memory or proposed one (memory.md
 * MEM-2, MEM-B6): what happened, and a link to the memory's own small Thread, where a
 * proposal waits for its review (ADR-0031 D5). The call's own record stays below it, collapsed.
 */
export default function MemorySavedBody({ save, payload, projectId }: { save: AgentMemorySave; payload: ToolCallPayload; projectId: string }) {
  const { t } = useTranslation();
  const proposed = save.state === "proposed";
  const outcome = proposed ? "proposed" : "kept";
  const sentence = save.title === null
    ? t(`memories.saved.${outcome}Personal`)
    : t(`memories.saved.${outcome}`, { title: save.title });
  return (
    <div className="space-y-1">
      <p className="app-text flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
        <BookmarkIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span role="status">{sentence}</span>
        {save.memoryId === null ? null : <MemoryThreadLink projectId={projectId} memoryId={save.memoryId} label={t(proposed ? "memories.saved.review" : "memories.openThread")} />}
      </p>
      <div className="text-xs"><ToolCallBody payload={payload} /></div>
    </div>
  );
}
